
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604124615799",
    "class": "icon",
    "viewBox": "0 0 1152 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1208",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1109.333333 0H42.666667C17.066667 0 0 17.066667 0 42.666667v938.666666c0 25.6 17.066667 42.666667 42.666667 42.666667h1066.666666c21.333333 0 42.666667-17.066667 42.666667-42.666667V42.666667c0-25.6-17.066667-42.666667-42.666667-42.666667z m-85.333333 896H128v-341.333333l170.666667-128 384 256 128-170.666667 213.333333 170.666667v213.333333zM896 384c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128 128 55.466667 128 128-55.466667 128-128 128z",
        "p-id": "1209"
      }
    }
  ]
})
    }
  